<template>
  <v-container>
    <Loading v-model="loading"></Loading>

    <v-form v-model="valid" ref="form">
      <v-container>

        <h2>（１）受験者情報の登録</h2>

        <p class="text-caption-scoped text-left">
          <span class="caption-title">【電子申請入力の注意事項】</span><br>
          ※入力内容に誤りがあると、試験に合格しても都道府県知事の登録を受けることが出来ない場合がありますのでご注意ください。<br>
          <strong>※戸籍通りの漢字が入力できない場合は「カタカナ」で入力してください。</strong><br>
          ※受験票、結果通知、合格証書など試験関連書類は戸籍通りの漢字を印字できない場合、カタカナに変更されることがあります。予めご了承ください。<br>
          ※オートコンプリート機能により入力された情報に誤りがある場合がございます。その場合には、お手数ですが一文字ずつ手入力で入力してください。<br><br>
          <span class="caption-title">【姓名の入力について】</span><br>
          現在住んでいる国、国籍により記載方法が異なります。下記、記載要領に従い入力してください。<br><br>
          <span class="caption-title">【記載要領】</span><br>
          <strong>＜日本国籍・日本居住者の方＞<br>
          戸籍に記載されている漢字氏名を入力 ※ローマ字は不可</strong><br>
          <br>
          ＜その他＞<br>
          日本国籍・外国居住者：パスポートに記載されている氏名をローマ字で入力 ※漢字氏名は不可<br>
          外国籍・日本居住者：在留カードに記載されている氏名をローマ字または漢字のどちらかを入力　※漢字とローマ字の併記は不可<br>
          外国籍・外国居住者：パスポートに記載されている氏名をローマ字で入力 ※漢字氏名は不可<br>
        </p>

        <v-row>
          <v-col>
            <v-text-field label="姓" v-model="form.lastName" placeholder="姓"
                          :disabled="disableEditName"
                          :rules="[rules.required]"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="ミドルネーム" v-model="form.middleName"
                          :disabled="disableEditName"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="名" v-model="form.firstName" placeholder="名"
                          :disabled="disableEditName"
                          :rules="[rules.required]"></v-text-field>
          </v-col>
        </v-row>
        <p class="text-caption-scoped text-left mt-5">
          ※フリガナは全角カタカナで入力してください。<br>
        </p>
        <v-row>
          <v-col>
            <v-text-field label="姓(フリガナ)" v-model="form.lastNameKana"
                          :disabled="disableEditName"
                          :rules="[rules.required, rules.kana]"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="ミドルネーム(フリガナ)" v-model="form.middleNameKana"
                          :disabled="disableEditName"
                          :rules="[rules.kana]"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field label="名(フリガナ)" v-model="form.firstNameKana"
                          :disabled="disableEditName"
                          :rules="[rules.required, rules.kana]"></v-text-field>
          </v-col>
        </v-row>


        <v-radio-group
          v-model="form.gender"
          row
          :disabled="disableEditName"
          :rules="[rules.required]"
        >
          <template v-slot:label>
            性別
          </template>
          <v-radio
            label="男"
            value="男"
          ></v-radio>
          <v-radio
            label="女"
            value="女"
          ></v-radio>
        </v-radio-group>

        <DatePicker v-model="form.birthdate"
                    label="生年月日"
                    baseDate="1995-01-01"
                    :rules="[rules.required]"
                    class="mt-12"
                    :disabled="submitted"
        ></DatePicker>

        <p class="text-caption-scoped text-left mt-12">
          「本籍」「国籍」は下記を確認のうえ、どちらか該当するものを入力（選択）してください。<br>
          <strong>＜日本国籍・日本居住者の方＞<br>
            【本籍】の項目にて、都道府県名を選択してください。 ※住居地ではありません。</strong><br>
            <br>
            ＜その他＞<br>
            日本国籍・外国居住者：【国籍】の項目にて、「Japan」を選択してください。 ※本籍の入力（選択）は日本居住者のみです。<br>
            外国籍・日本居住者：【国籍】の項目にて、在留カードに記載されている国籍を選択または入力してください。<br>
            外国籍・外国居住者：【国籍】の項目にて、パスポートに記載されている国籍を選択または入力してください。<br>
        </p>

        <v-select label="本籍(都道府県) ※日本国籍かつ日本居住者の場合"
                  :rules="[rules.permanentAddress]"
                  :disabled="disableEditName || (!form.permanentAddress && !!form.nationality && form.nationality!='日本')"
                  v-model="form.permanentAddress" :items="prefectures"></v-select>

        <v-row>
          <v-col>
            <v-autocomplete label="国籍 ※外国籍の場合、または日本国籍かつ外国居住者の場合"
                      :rules="[rules.nationality]"
                      :disabled="disableEditName || !!form.permanentAddress"
                      v-model="form.nationality" :items="countries"></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field label="国籍（その他・others）"
                          :disabled="disableEditName || !!form.permanentAddress || !hasSelectNationalityOther"
                          v-model="form.nationalityOther"
                          :rules="[rules.nationalityOther]"></v-text-field>
          </v-col>
        </v-row>


        <v-row
          class="mt-12">
          <v-col class="text-center" cols="12" md="6">
            <v-img :src="form.pictureUrl" width="240" height="320" v-if="form.pictureUrl" class="ma-auto"
                   @click="clickUpload"
            ></v-img>
            <v-card
              v-else
              class="ma-auto"
              color="grey lighten-1"
              width="240" height="320"
              @click="clickUpload"
            ></v-card>
            <v-btn
              color="primary"
              class="text-none"
              rounded
              depressed
              :loading="isSelecting"
              @click="clickUpload"
              :disabled="submitted && !requiredResubmit"
            >
              <v-icon left>
                cloud_upload
              </v-icon>
              写真をアップロード
            </v-btn>
            <v-text-field :rules="[rules.photo]" class="photo-message"></v-text-field>
            <!--            <v-file-input label="写真" @change="uploadPhoto"-->
            <!--                          :rules="[rules.photo]"-->
            <!--                          accept="image/*"-->
            <!--                          class="d-none"-->
            <!--                          ref="uploader"-->
            <!--            ></v-file-input>-->
            <input type="file"
                   @change="onFileChanged"
                   :rules="[rules.photo]"
                   accept="image/*"
                   class="d-none"
                   ref="uploader"/>
          </v-col>
          <v-col>
            <p class="text-caption-scoped text-left">
            ※写真撮影年月を選択してください。
            </p>
            <DatePicker v-model="form.pictureDate" label="写真撮影年月" month
                        :min="minPictureDate"
                        :disabled="submitted && !requiredResubmit"
                        :rules="[rules.required]"></DatePicker>
            <p class="text-caption-scoped text-left">
              【写真内容の規定】<br />
              〇カラー又は白黒で、申請日より6 カ月以内に撮影したもの<br />
              〇縦320ピクセル×横240ピクセル（縦4cm×横3cm）<br />
              〇無帽、無背景で、ご本人のみが写っているもの<br />
              〇自然な表情で、目をしっかり開けた状態で撮影されたもの<br />
              〇体全体が正面を向き、カメラ目線で撮影されたもの<br />
              〇受験時に眼鏡を使用する場合、眼鏡をかけて撮影したもの<br />
              （当日の着用有無が未定の方は、眼鏡を外した状態で撮影して下さい）<br />
              〇本人の肩から上、頭頂部まで顔や輪郭がはっきりと判別できるもの<br />
              <br />
              ※以下のような写真は申請写真として認められません。<br />
              ×前髪で目や顔が隠れてしまうようなもの<br />
              ×帽子、マスク、サングラス等を着用しているもの<br />
              ×ほかの人物や動物及び特定できる文字や建物が映っているもの<br />
              ×背景の色が強いもの<br />
              ×正面を向いていないもの<br />
              ×顔の輪郭が枠から出ているもの<br />
              ×画像が全体的に暗く、顔が特定しにくいもの<br />
              ×画像が粗く、ぼやけているもの
            </p>
          </v-col>
        </v-row>
        <div style="text-align: center;">
          <img
            src="https://cms.kentei-uketsuke.com/img/sys/ty/ng50.jpg"
            alt="画像"
            style="max-width: 80%; height: auto;"
          />
        </div>
        <h3 class="mt-12">現住所</h3>

        <p class="text-caption-scoped text-left">
          ※日本居住者は住民票または在留カードの記載どおりに入力してください。<br>
          <strong>※郵便番号・都道府県・市区町村・番地・建物名・号棟・部屋番号まで漏れなく入力して下さい。</strong><br>
          ※外国居住者は国名を含めて入力してください。<br>
          ※郵便番号は半角英数字で入力して下さい。また、 ‐（ハイフン）を含む郵便番号の場合は、‐（ハイフン）も必ずご入力ください。
        </p>

        <v-text-field label="郵便番号" v-model="form.zipcode"
                      validate-on-blur
                      :rules="[rules.hankaku]"
                      :disabled="disableAll"
                      @change="checkZipcode($event,true)"
                      :error-messages="zipcodeError"></v-text-field>
        <v-text-field label="住所（都道府県・市区町村・町名）" v-model="form.address" :rules="[rules.required]" :disabled="disableAll"></v-text-field>
        <v-text-field label="丁・番地" v-model="form.address2" :rules="[rules.required]" :disabled="disableAll"></v-text-field>
        <v-text-field label="アパート・マンション・ビル名等" v-model="form.address3" :disabled="disableAll"></v-text-field>


        <h3 class="mt-12">日中に受験者本人につながる連絡先</h3>

        <p class="text-caption-scoped text-left">
          必ず受験者本人の電話番号を入力してください。<br>
          ※電話番号は1つのみ入力してください。複数ある場合は「緊急連絡先」に入力してください。<br>
          ※外国居住者は国番号も含めて入力してください。<br>
          ※ ‐（ハイフン）を含めた半角数字で入力してください。
        </p>
        <v-text-field label="電話番号・携帯番号" v-model="form.tel" :rules="[rules.required,rules.tel]" :disabled="disableAll"></v-text-field>

        <v-text-field label="FAX番号（入力は任意）" v-model="form.fax" :rules="[rules.tel]" :disabled="disableAll"></v-text-field>

        <h3>緊急連絡先</h3>
        <p class="text-caption-scoped text-left">
          ※日中に連絡が取れる連絡先として該当するものを「緊急連絡先種別」のプルダウンメニューから選択してください。<br>
          ※「緊急連絡先種別」が「その他」の場合、代理人・家族の氏名等を具体的に入力してください。<br>
          <span style="color: red;">※万が一、申請内容等の確認が急ぎ必要な際、ご本人様とご連絡が取れない場合に、事務局より緊急連絡先にご連絡をする可能性がございます。予めご了承ください。</span>
        </p>
        <v-row>
          <v-col>
            <v-select label="緊急連絡先種別" v-model="form.urgentType" :items="urgentTypes"
                      :rules="[rules.required]" :disabled="disableAll"></v-select>
          </v-col>
          <v-col>
            <v-text-field label="その他の場合、代理人・家族の氏名を記載" v-model="form.urgentTypeOther"
                          :rules="[rules.urgentTypeOther]"
                          :disabled="disableAll || form.urgentType != 'その他'"></v-text-field>
          </v-col>
        </v-row>
        <v-text-field label="緊急連絡先電話番号・携帯番号" v-model="form.urgentTel"
                      :rules="[rules.required,rules.tel]"
                      :disabled="disableAll"></v-text-field>

        <v-text-field label="緊急連絡先FAX番号（入力は任意）" v-model="form.urgentFax" :rules="[rules.tel]"
                      :disabled="disableAll"></v-text-field>


        <h3>配慮事項</h3>
        <p class="text-caption-scoped text-left">
          ※身体の障がい等により特別な手配が必要な方は、希望する配慮事項と配慮が必要な理由を入力してください。<br>
          ※「特に無し」等の入力は不要です。試験に伴う配慮事項以外は入力しないでください。
        </p>
        <v-textarea label="希望する配慮事項" v-model="form.consideration"
                    :disabled="disableAll || isAfterOralExamResultOpenAt"
        ></v-textarea>


        <div v-if="submitted" class="text-left">
          <h3>出願後に受験者情報が変更になった場合に必要な提出書類</h3>
          <p class="text-caption-scoped text-left">
            〇書類提出が必要な項目<br />
            【本籍・国籍】全部事項証明書（戸籍謄本）・個人事項証明書（戸籍抄本）・パスポート・在留カード<br />
            【氏名】上記4点他、婚姻届受理証明書<br />
            証明書類の提出が必要な項目を変更する場合は、証明書類をアップロードしてください。
          </p>
          <span v-for="item in form.documents" :key="item.fileId" class="mr-1">
            <v-chip :href="item.url" :close="!disableAll"
                    @click:close="removeDocument(item)">
              {{ item.key|fileName }}
            </v-chip>
          </span>
          <v-file-input show-size
                        label="ファイルアップロード"
                        multiple
                        :disabled="disableAll"
                        @change="upload"></v-file-input>
        </div>

        <p class="text-caption-scoped d-inline-block text-left">
          ※「確定する」ボタンをクリックしても画面上部に「確定しました」と表示が出ない場合は、<br>
          　必須項目に未入力・未登録の項目があります。該当箇所に赤字で不備内容が表示されますので、<br>
          　表示を確認の上、全て入力・登録をしてください。<br>
          <span class="red--text font-weight-bold">※入力内容や申請内容に不備があった場合は再提出となります。期日までに申請不備が<br>
          　解消されない場合は申込申請を受理することができません。入力内容に誤りが無い<br>
          　か再度確認してください。</span>
        </p>
        <div class="text-center">
          <v-btn to="/mypage" class="mx-2">マイページに戻る</v-btn>
          <v-btn @click.stop="save" class="mx-2" v-if="!submitted">一時保存する</v-btn>
          <v-btn color="primary" @click.stop="submit" class="mx-2" v-if="!disableAll">確定する</v-btn>
        </div>
      </v-container>
    </v-form>

  </v-container>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
import DatePicker from '../components/DatePicker'
import {prefectures} from '../../data/prefectures.json'
import countries from '../../data/countries.json'
import Rules from '../mixins/RulesMixin'
import Loading from '../components/Loading'
import ZipCodeChecker from '../mixins/ZipCodeChecker'
import {mapGetters} from 'vuex'
import _ from 'lodash';

export default {
  components: {DatePicker, Loading},
  mixins: [Rules, ZipCodeChecker],
  data () {
    return {
      loading: true,
      form: {
        lastName: '',
        firstName: '',
        middleName: '',
        lastNameKana: '',
        firstNameKana: '',
        middleNameKana: '',
        gender: '',
        birthdate: '',
        permanentAddress: '',
        nationality: '',
        nationalityOther: '',
        picture: '',
        pictureDate: '',
        pictureUrl: '',
        zipcode: '',
        address: '',
        address2: '',
        address3: '',
        tel: '',
        fax: '',
        urgentType: '',
        urgentTypeOther: '',
        urgentTel: '',
        urgentFax: '',
        consideration: '',
        documents: []
      },
      draftForm: {
        lastName: '',
        firstName: '',
        middleName: '',
        lastNameKana: '',
        firstNameKana: '',
        middleNameKana: '',
        gender: '',
        birthdate: '',
        permanentAddress: '',
        nationality: '',
        nationalityOther: '',
        picture: '',
        pictureDate: '',
        pictureUrl: '',
        zipcode: '',
        address: '',
        address2: '',
        address3: '',
        tel: '',
        fax: '',
        urgentType: '',
        urgentTypeOther: '',
        urgentTel: '',
        urgentFax: '',
        consideration: '',
        documents: []
      },
      rules: {
        photo: (v) => {
          return (!!this.form.pictureUrl) || '必須項目です'
        },
        permanentAddress: (v) => {
          return (!!v || !!this.form.nationality) || '日本国籍かつ日本居住者の場合は必須項目です'
        },
        nationality: (v) => {
          return (!!v || !!this.form.permanentAddress) || '外国籍の場合、または日本国籍かつ外国居住者の場合は必須項目です'
        },
        nationalityOther: (v) => {
          return (!!v || this.form.nationality != 'その他') || '国籍が「その他」の場合必須'
        },
        notifyAddress: (v) => {
          return !!this.form.notifySameAddress || !!v || '必須項目です'
        },
        urgentTypeOther: (v) => {
          return (!!v || this.form.urgentType != 'その他') || '緊急連絡先種別が「その他」の場合必須'
        },
        notifyZipcode: (v) =>{
          return !this.notifyZipcodeError || this.notifyZipcodeError
        }
        //   required: v => !!v || '必須項目です',
        //   tel: v => /^[+]?[\d-]*$/.test(v) || '番号が正しくありません',
        //   zip: v => /^[\d-]*$/.test(v) || '番号が正しくありません',
        //   kana: v => /^[ァ-ヶー　]*$/.test(v) || '全角カタカナで入力してください',
      },
      schema: {
        birthdate: {
          type: 'text',
          title: '生年月日'
        }
      },
      valid: false,
      countries: [],
      prefectures: [],
      urgentTypes: [
        '自宅',
        '携帯電話',
        '勤務先',
        'その他'
      ],
      // telRule: [this.rules.tel],
      // zipcodeRule: [this.rules.zipcode]
      isSelecting: false,
      zipcodeError: [],
      zipcodeInJapan: false,
      notifyZipcodeError: []
    }
  },
  async created () {
    this.loading = true
    let p1 = this.fetchCountries()
    let p2 = this.fetchPrefectures()
    let p3 = this.fetchSaved()
    await Promise.all([p1, p2, p3])
    this.loading = false
  },
  computed: {
    hasChanged () {
      return !_.isEqual(this.draftForm,this.form)
    },
    ...mapGetters([
      'entryOpened',
      'isAfterRegistrationEnd',
      'isAfterWrittenExamTicketOpen',
      'isAfterWrittenExamResultOpen',
      'isAfterOralExamTicketOpen',
      'isAfterOralExamResultOpenAt',
      'isAfterUpdateDeadline',
    ]),
    submitted () {
      return this.$store.getters.submitted
    },
    requiredResubmit () {
      return this.$store.getters.requiredResubmit
    },
    hasSelectNationalityOther () {
      return this.form.nationality === 'その他'
    },
    minPictureDate () {
      return dayjs().subtract(6, 'month').format()
    },
    disableEditName(){
      if(this.isAfterUpdateDeadline) return true;
      if(this.isAfterOralExamResultOpenAt) return true;
      if(this.isAfterOralExamTicketOpen) return true;
      if(this.isAfterWrittenExamResultOpen) return true;
      if(this.isAfterWrittenExamTicketOpen) return true;
      if(this.requiredResubmit) return false;
      if(this.submitted) return true;
      return false;
    },
    disableAll(){
      if(this.isAfterUpdateDeadline) return true;
      return false;
    }
  },
  filters: {
    fileName (v) {
      return v && v.substring(v.lastIndexOf('/') + 1)
    }
  },
  watch: {},
  methods: {
    async checkZipcode (v, updateAddress) {
      //海外のzipcodeも可とする
      let ret = await this.findZipCode(v)
      if (!ret) {
        this.zipcodeInJapan = false
        return
      }
      this.zipcodeInJapan = true
      if (updateAddress) {
        this.form.address = ret.prefecture + ret.city + ret.street
      }
    },
    async checkNotifyZipcode (v) {
      this.notifyZipcodeError = [];
      let ret = await this.findZipCode(v)
      if (!ret) {
        this.notifyZipcodeError = '実在する日本国内の郵便番号ではありません'
      }
      this.form.notifyAddress = ret.prefecture + ret.city + ret.street
    },
    async checkJapanAddress (event, v) {
      if (!this.zipcodeInJapan) {
        await this.checkZipcode(this.form.zipcode)
      }
      if (!this.zipcodeInJapan) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
        alert('現住所に日本国内に存在しない郵便番号が入力されています。正しく入力してください。')
        this.form.notifySameAddress = false
        return false
      }
    },
    async fetchPrefectures () {
      this.prefectures = prefectures.map(v => v.name)
      this.prefectures.unshift('')
    },
    async fetchCountries () {
      this.countries = countries.map(v => v.companyjp)
      this.countries.push('その他')
      this.countries.unshift('')
    },
    async fetchSaved () {
      let {data} = await axios.get('/api/entry/draft')
      if (data) {
        this.form = Object.assign(this.form, data)
        this.draftForm = _.cloneDeep(this.form)
      }
    },
    clickUpload () {
      if (this.submitted && !this.requiredResubmit) return false
      this.$refs.uploader.click()
    },
    onFileChanged (e) {
      this.uploadPhoto(e.target.files[0])
    },
    async uploadPhoto (file) {
      //size
      if (file.size > 10485760) {
        alert('ファイルサイズは10MB以下でアップロードしてください')
        return
      }
      this.isSelecting = true
      if (!file) {
        this.form.picture = null
        this.form.pictureUrl = null
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload/photo', params)
      this.form.picture = data.id
      this.form.pictureUrl = data.url
      this.isSelecting = false
    },
    removeDocument (item) {
      this.form.documents = this.form.documents.filter(v => v.fileId != item.fileId)
    },
    async upload (file) {
      if (!file) return
      if (Array.isArray(file)) {
        this.loading = true
        try {
          for (let i in file) {
            await this.upload(file[i])
          }
        }catch (e){
          console.error(e)
        }
        this.loading = false
        return
      }
      if (file.size > 20971520) {
        alert('ファイルサイズは20MB以下でアップロードしてください')
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload', params)
      this.form.documents = [...this.form.documents,{
        fileId: data.id,
        key: file.name
      }]
    },
    async save () {
      try {
        await axios.post('/api/entry/save', this.form)
        this.$emit('toast', '保存しました')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
    async submit () {
      try {
        if (this.submitted && !this.hasChanged) {
          this.$emit('error', '前回提出時の内容に対して、修正・変更がない状態での提出。')
          return
        }

        if (!this.$refs.form.validate()) {
          this.$emit('error', '入力項目にエラーがあります')
          return
        }
        await axios.post('/api/entry/submit', this.form)
        this.$emit('toast', '確定しました')
        if (this.submitted) return
        await this.$router.push('/select')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 1rem;
  text-align: left;
  color: #363636;
  background-color: #F5F5F5;
  padding: 0.3rem;
}
.caption-title{
  text-align: left;
  font-size: 130%;
  font-weight: bold;
  /*color: #959595;*/
}
</style>
<style>
.photo-message .v-messages {
  text-align: center;
}

.photo-message .v-input__slot {
  display: none;
}
</style>
